import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ModalMultipleChoicePageRoutingModule } from "./modal-multiple-choice-routing.module";

import { ModalMultipleChoicePage } from "./modal-multiple-choice.page";

@NgModule({
  declarations: [ModalMultipleChoicePage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalMultipleChoicePageRoutingModule,
  ],
})
export class ModalMultipleChoicePageModule {}
